import { grScope } from "@gr-common/async/logger";

const log = grScope.scope("legacy.debug");

otto.debug.assignNamespace({
  sendLog: (namespace, data) => {
    log.warn("sendLog is deprecated, use apm.sendCustomError instead");
    return otto.apm.sendCustomError(namespace, data);
  },
});
